import { createAsyncActionType } from './index';

export const GET_NEWS = createAsyncActionType('news', 'GET_NEWS');
export const GET_NEWS_DETAIL = createAsyncActionType('news', 'GET_NEWS_DETAIL');
